import React from 'react'
import FormCheckbox from '../../../../library/form/components/FormCheckbox';
import FormROValue from "../../../../library/form/components/FormROValue1"

const RolePrivilegeEditorRow = (props) => {
    const { formObject, rowValueKey } = props;
    
    if( rowValueKey === "docType")
        return(null);

    return (
        <li>
            <FormCheckbox formObject={formObject} rowKey="" action={{ paramName: rowValueKey }} />
            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: rowValueKey }} />
        </li>
    )
}

export default RolePrivilegeEditorRow